import { ExportDataType } from '@conversed/shared/src/central/dto/export.dto';
import type React from 'react';

import { useExportConfig } from '../../../../hooks/settings/exports/useExportConfig';
import { useExportConfigActions } from '../../../../hooks/settings/exports/useExportConfigActions';
import ExportConfigDataModal from './ExportConfigDataModal';

export const EditExportConfigModal: React.FC = () => {
  const { selectedExportConfig, exportConfigs } = useExportConfig();
  const { editExportConfig } = useExportConfigActions();

  if (!selectedExportConfig) {
    return <></>;
  }

  const hasHistoryExport = exportConfigs.some(
    (config) =>
      config.dataType === ExportDataType.History &&
      config.id !== selectedExportConfig.id,
  );

  return (
    <ExportConfigDataModal
      onSubmit={editExportConfig}
      hasHistoryExport={hasHistoryExport}
      data={selectedExportConfig}
    />
  );
};

export default EditExportConfigModal;
